/**
 * UserTable
 *
 * Configurable admin table that renders active or deleted users based on
 * `tableConfig`. Delegates row rendering to `UserRow`/`DeletedUserRow`.
 */
import React from 'react';
import UserRow from './UserRow';
import DeletedUserRow from './DeletedUserRow';
import { DeletedUserTableHeader } from './DeletedUserTableHeader';
import { ActiveUserTableHeader } from './ActiveUserTableHeader';

const UserTable = ({ 
  users,
  getSortIcon,
  handleSort,
  tableConfig = {},
  userRowProps = {}
}) => {
  const {
    showTrialEnd = false,
    showSubscriptionInfo = true,
    showCancellationDate = false,
    showDeletionDate = false,
    showNextDecisionDate = false,
    showFreeUser = true,
    showActions = true,
    isDeletedUsers = false,
    tableId = 'default'
  } = tableConfig;

  // Render deleted users table
  if (isDeletedUsers) {
    return (
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
          <DeletedUserTableHeader 
            getSortIcon={getSortIcon}
            handleSort={handleSort}
            tableId={tableId}
          />
          <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
            {users.map((user) => (
              <DeletedUserRow
                key={user.id}
                deletedUser={user}
                {...userRowProps}
              />
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  const isEnterpriseSection = tableId === 'enterpriseUsers';

  // Render active users table
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
        <ActiveUserTableHeader 
          getSortIcon={getSortIcon}
          handleSort={handleSort}
          tableConfig={tableConfig}
          tableId={tableId}
          isEnterpriseSection={isEnterpriseSection}
        />
        <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
          {users.map((user) => (
            <UserRow
              key={user.uid}
              user={user}
              showTrialEnd={showTrialEnd}
              showSubscriptionInfo={showSubscriptionInfo}
              showNextDecisionDate={showNextDecisionDate}
              showCancellationDate={showCancellationDate}
              showDeletionDate={showDeletionDate}
              showFreeUser={showFreeUser}
              showActions={showActions}
              isEnterpriseSection={isEnterpriseSection}
              {...userRowProps}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default UserTable;
